import { Pipe, PipeTransform } from '@angular/core';
import { TableFacets, TableFacetsValue } from '../models/utils-table';

@Pipe({
  name: 'facetsByColumnKey',
  standalone: true
})
export class FacetsByColumnKeyPipe implements PipeTransform {
  transform(data: TableFacets[], columnKey: string): TableFacetsValue[] {
    if (!data || !columnKey) {
      return [];
    }

    return data.find(({ name }) => name === columnKey)?.values || [];
  }
}
